// extracted by mini-css-extract-plugin
module.exports = {"info":"profile_info__25Vz1"};